import {CSSProperties, FC} from 'react';


export interface IIconMileageProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconMileage: FC<IIconMileageProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m7.74 21-.119-.067A9.054 9.054 0 0 1 3 13.031C3 8.051 7.037 4 12 4s9 4.051 9 9.031c0 3.281-1.77 6.309-4.621 7.902l-.12.067H7.74Zm12.205-7.969c0-4.394-3.564-7.969-7.945-7.969s-7.945 3.575-7.945 7.97C4.055 15.88 5.553 18.576 8 20h7.969c2.446-1.423 3.976-4.12 3.976-6.969ZM8.982 16.788 7.49 18.29a1.443 1.443 0 0 0-.122-.126c-.494-.48-2.259-2.199-2.259-5.134 0-3.813 3.108-6.906 6.891-6.906 3.787 0 6.89 3.097 6.89 6.906 0 2.943-1.756 4.647-2.255 5.131-.066.065-.11.107-.125.129l-1.492-1.503.746-.752.729.735a5.82 5.82 0 0 0 1.32-3.209H16.78V12.5h1.03a5.82 5.82 0 0 0-1.325-3.202l-.722.728-.746-.751.721-.727a5.806 5.806 0 0 0-3.212-1.336V8.25h-1.054V7.212A5.805 5.805 0 0 0 8.26 8.548l.72.727-.745.751-.722-.728A5.822 5.822 0 0 0 6.188 12.5h1.03v1.063h-1.03a5.817 5.817 0 0 0 1.319 3.208l.729-.735.746.752Zm4.51-3.226h2.235V12.5H13.49A1.585 1.585 0 0 0 12 11.437a1.59 1.59 0 0 0-1.582 1.594c0 .879.71 1.594 1.582 1.594.688 0 1.274-.444 1.491-1.063Zm-2.02-.53A.53.53 0 0 1 12 12.5a.53.53 0 0 1 .527.531.53.53 0 0 1-.527.531.53.53 0 0 1-.527-.53ZM14 19v-1h-4v1h4Z" clipRule="evenodd" />
        </svg>
    );
};
